import { render, staticRenderFns } from "./DetalhesApresentacao.vue?vue&type=template&id=95ef9c00&scoped=true&"
import script from "./DetalhesApresentacao.vue?vue&type=script&lang=js&"
export * from "./DetalhesApresentacao.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesApresentacao.vue?vue&type=style&index=0&id=95ef9c00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ef9c00",
  null
  
)

export default component.exports